import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';

const options = {
  fallbackLng: 'English',
  // name of json file
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false, // we use content as keys
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ','
  },

  react: {
    wait: true
  }
};

i18n.use(XHR);

export default () => {
  i18n
    .use(LanguageDetector)
    .init(options);
  return i18n;
};



// WEBPACK FOOTER //
// ./src/i18n.js